import React from "react";
import { Container, Row, Col, Card, CardBody, Button, Label, Input, FormFeedback } from "reactstrap";

import { withRouter } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Changepassword = () => {
  //meta title
  document.title = "Change Password";
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };


  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      old_password: '',
      new_password: '',
      new_confirm_password: '',
    },
    validationSchema: Yup.object({
      old_password: Yup.string().required('Old password is required'),
      new_password: Yup.string()
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/\d/, 'Password must contain at least one numeric character')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('New password is required')
        .min(8, 'Password must be at least 8 characters')
        .max(20, 'Password must be at most 20 characters'),
      new_confirm_password: Yup.string()
        .oneOf([Yup.ref('new_password'), null], 'Both passwords need to be the same !')
        .required('New confirm password is required')
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          old_password: values.old_password,
          new_password: values.new_password,
          new_confirm_password: values.new_confirm_password,
        });
        const res = await postRequest('profile-change-password', jsonpar);
        if (res && res.code === 200) {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update Password';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });


  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Eshepay" breadcrumbItem="Change Password" />
          <Row>
            <Col xs="12">
              <div className="">
                <Row>
                  <Col lg="12">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Old password :</Label>
                              <Input type="password" placeholder="Enter old password"
                                name="old_password"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                value={validation1.values.old_password || ""}
                                invalid={
                                  validation1.touched.old_password && validation1.errors.old_password ? true : false
                                }
                              />
                              {validation1.touched.old_password && validation1.errors.old_password ? (
                                <FormFeedback type="invalid">{validation1.errors.old_password}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4} md={6} xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">New password :</Label>
                              <Input type="password" placeholder="Enter new password"
                                name="new_password"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                value={validation1.values.new_password || ""}
                                invalid={
                                  validation1.touched.new_password && validation1.errors.new_password ? true : false
                                }
                              />
                              {validation1.touched.new_password && validation1.errors.new_password ? (
                                <FormFeedback type="invalid">{validation1.errors.new_password}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={4} md={6} xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">New confirm password :</Label>
                              <Input type="password" placeholder="Enter new confirm password"
                                name="new_confirm_password"
                                onChange={validation1.handleChange}
                                onBlur={validation1.handleBlur}
                                value={validation1.values.new_confirm_password || ""}
                                invalid={
                                  validation1.touched.new_confirm_password && validation1.errors.new_confirm_password ? true : false
                                }
                              />
                              {validation1.touched.new_confirm_password && validation1.errors.new_confirm_password ? (
                                <FormFeedback type="invalid">{validation1.errors.new_confirm_password}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                        <div className="text-left mt-3 mb-2">
                          <Button type="button" className="btn btn-primary-default"
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          >Update Password</Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Changepassword);
